export const hasFeatureLimit = (featureLimits, featureLimitKey) =>
  Boolean(featureLimits?.[featureLimitKey]?.featureLimit)
